export function useTelegramMainButton() {
	const main_store = useMainStore();

	const isTelegramEnv = typeof window !== 'undefined' && window.Telegram?.WebApp?.platform !== 'unknown'
	console.log('isTelegramEnv', isTelegramEnv);

	// Инициализация Telegram MainButton
	if (isTelegramEnv && window.Telegram?.WebApp?.MainButton && !main_store.is_tg_main_button_handler_inited) {
		main_store.set_value('is_tg_main_button_handler_inited', true);
		const MainButton = window.Telegram.WebApp.MainButton;
		MainButton.onClick(async () => {
			if (main_store.tg_main_button_handler) {
				try {
					await main_store.tg_main_button_handler();
				} catch (error) {
					console.error('Error in MainButton handler:', error);
				}
			}
		});
	}

	// Установка обработчика
	const setMainButtonHandler = (handler: () => void | Promise<void>) => {
		console.warn('setMainButtonHandler', handler);
		main_store.set_value('tg_main_button_handler', handler);
	};

	// Очистка обработчика
	const clearMainButtonHandler = () => {
		console.log('clearMainButtonHandler');
		main_store.set_value('tg_main_button_handler', () => {});
	};

	// Получение текущего обработчика
	const getMainButtonHandler = () => {
		console.log('getMainButtonHandler');
		return main_store.tg_main_button_handler;
	};

	// Показать кнопку
	const showMainButton = () => {
		console.log('showMainButton');
		if (isTelegramEnv && window.Telegram?.WebApp?.MainButton) {
			window.Telegram.WebApp.MainButton.show();
		}
		main_store.set_value('is_tg_main_button_visible', true);
		// main_store.is_tg_main_button_visible = true;
	};

	// Скрыть кнопку
	const hideMainButton = () => {
		console.log('hideMainButton');
		if (isTelegramEnv && window.Telegram?.WebApp?.MainButton) {
			window.Telegram.WebApp.MainButton.hide();
		}
		main_store.set_value('is_tg_main_button_visible', false);
		// main_store.is_tg_main_button_visible = false;
	};

	const isMainButtonVisible = main_store.is_tg_main_button_visible;

	const setMainButtonText = (text: string) => {
		console.log('setMainButtonText', text);
		if (isTelegramEnv && window.Telegram?.WebApp?.MainButton) {
			window.Telegram.WebApp.MainButton.setText(text);
		}
		main_store.set_value('tg_main_button_text', text);
		// main_store.tg_main_button_text = text;
	};

	const setMainButtonColor = (color: string) => {
		console.log('setMainButtonColor', color);
		if (isTelegramEnv && window.Telegram?.WebApp?.MainButton) {
			window.Telegram.WebApp.MainButton.setParams({ color });
		}
		main_store.set_value('tg_main_button_color', color);
		// main_store.tg_main_button_color = color;
	};

	return {
		setMainButtonHandler,
		clearMainButtonHandler,
		getMainButtonHandler,
		showMainButton,
		hideMainButton,
		isMainButtonVisible,
		setMainButtonText,
		setMainButtonColor,
	};
}